import React from "react";
import { ExternalLink } from "lucide-react";

const SurveyPage: React.FC = () => {
  // Google Forms survey link
  const surveyLink = "https://forms.gle/ovzLKUS9NP32rDNy7";

  // Function to open survey in a new tab
  const openSurvey = () => {
    window.open(surveyLink, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-center mb-6">
        Site Survey - Win a Free Cold Case Download!
      </h1>

      <div className="bg-card rounded-lg p-8 shadow-md">
        <div className="space-y-6">
          <div className="text-center space-y-4">
            <p className="text-xl">
              Browse our site and fill out our quick survey for a chance to win
              one of 20 free cold case downloads!
            </p>

            <p className="text-muted-foreground">
              We value your feedback! Simply visit our site, explore what we
              have to offer, and complete the survey to enter our giveaway.
            </p>
          </div>

          <div className="border-t border-b py-6 my-6">
            <h2 className="text-2xl font-semibold mb-4">How it Works:</h2>
            <ol className="list-decimal pl-6 space-y-3">
              <li>
                Browse through our website to get familiar with our cold case
                offerings
              </li>
              <li>Click the button below to open our survey</li>
              <li>
                Complete all questions honestly - your feedback helps us
                improve!
              </li>
              <li>Enter your email at the end of the survey</li>
              <li>
                20 lucky participants will receive a free cold case download
              </li>
            </ol>
          </div>

          <div className="text-center">
            <button
              onClick={openSurvey}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-6 py-3 rounded-md font-medium flex items-center gap-2 mx-auto"
            >
              Take the Survey <ExternalLink className="h-4 w-4" />
            </button>

            <p className="mt-4 text-sm text-muted-foreground">
              The survey takes approximately 5 minutes to complete.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyPage;
